import { useAuth } from 'hooks/auth'

/**
 * Whose data a shared read belongs to: the tenant and the user the server answered for.
 *
 * Keys every in-flight read that is shared between screens (the owner directory), so a cached answer can never
 * outlive the identity that earned it — signing out navigates without a reload, and the company switch happens in-tab.
 */
export const useTenantScope = (): string => {
    const { application, user } = useAuth()
    return `${application?.id ?? ''}:${user?.id ?? ''}`
}
